import React from "react";
import MessengerCustomerChat from "react-messenger-customer-chat";
const Fbchat = () => {
  return (
    <div>
      {/* <MessengerCustomerChat pageId="106279360798692" appId="910231926724497" /> */}
      {/* <MessengerCustomerChat pageId="134888956370275" appId="1059473441737382" themeColor={'#00264D'} minimized={'true'}/> */}
      <MessengerCustomerChat
        pageId="911305985395825"
        appId="1059473441737382"
        themeColor={"#00264D"}
        minimized={"true"}
      />
    </div>
  );
};

export default Fbchat;
